import {
  passwordScore,
  strengthColor,
  strengthHint,
  strengthLabel,
} from "@/lib/password-strength";

export const StrengthGauge = ({
  failedShort,
  id,
  password,
}: {
  failedShort: boolean;
  id: string;
  password: string;
}) => {
  const score = passwordScore(password);
  const color = strengthColor(score);
  const hint = strengthHint(password, score, failedShort);
  const label = strengthLabel(score);

  return (
    <div className="flex flex-col gap-2 pt-1">
      <div aria-hidden className="grid grid-cols-4 gap-1.5">
        {[1, 2, 3, 4].map((segment) => (
          <div
            className="auth-gauge h-1 rounded-full"
            key={segment}
            style={{
              background: segment <= score ? color : "#DDE2EB",
              transition: "background-color 220ms cubic-bezier(.2,.7,.2,1)",
            }}
          />
        ))}
      </div>
      <div
        className="flex items-baseline justify-between gap-4 text-sm leading-[1.45]"
        id={id}
      >
        <span
          aria-live="polite"
          className={failedShort ? "text-error" : "text-n-600"}
        >
          {hint}
        </span>
        {label ? (
          <span className="shrink-0 font-semibold" style={{ color }}>
            {label}
          </span>
        ) : null}
      </div>
    </div>
  );
};
